import React, { useMemo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  Typography,
  Avatar,
  Chip,
  Button,
  IconButton,
  Container,
} from "@mui/material";
import { getUsers } from "../../services/user_Service";
import { useAdminMode } from "../../../adminTheme";
import { getImageUrlAdminToken } from "../../utills/ImagesUtilsAdmin";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [totalRows, setTotalRows] = useState(0);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate();



  console.log("Users", users);

  // Fetch users with pagination and filtering
  useEffect(() => {
    const fetchUsers = async () => {
      setIsLoading(true);
      try {
        // Convert to API expected format (1-based pagination)
        const page = pagination.pageIndex + 1;
        const per_page = pagination.pageSize;

        const data = await getUsers(navigate, globalFilter, page, per_page);
        if (data) {
          setUsers(data.users || []);
          setTotalRows(data.pagination.total || 0);
        }
      } catch (error) {
        // Handle error case
      } finally {
        setIsLoading(false);
      }
    };

    // Add debounce for search to avoid excessive API calls
    const timeoutId = setTimeout(() => {
      fetchUsers();
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [navigate, pagination.pageIndex, pagination.pageSize, globalFilter]);

  const highlightText = (text, searchTerm) => {
    if (!searchTerm) return text;
    const regex = new RegExp(`(${searchTerm})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? (
        <span
          key={index}
          style={{ backgroundColor: "#ffcc80", fontWeight: "bold" }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "thumbnail_pic",
        header: "Profile",
        Cell: ({ cell }) => {
          const value = cell.getValue();
          const username = cell.row.original.username;
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {value ? (
                <img
                  src={getImageUrlAdminToken(value)}
                  alt="Profile"
                  style={{ width: 40, height: 40, borderRadius: "50%" }}
                />
              ) : (
                <Avatar sx={{ width: 40, height: 40 }}>
                  {username[0]?.toUpperCase()}
                </Avatar>
              )}
              <span style={{ marginLeft: 1, padding: "5px" }}>
                {highlightText(username, globalFilter)}
              </span>
              <Button
                variant="outlined"
                size="small"
                color="primary"
                onClick={() => navigate(`/users/${cell.row.original.id}`)}
                sx={{ marginLeft: "auto" }}
              >
                View
              </Button>
            </div>
          );
        },
      },
      {
        accessorKey: "name",
        header: "Name",
      },
      {
        accessorKey: "email",
        header: "Email",
      },
      {
        accessorKey: "phone",
        header: "Phone",
      },
      {
        accessorKey: "status",
        header: "Status",
        Cell: ({ cell }) =>
          cell.getValue() == 1 ? (
             <Chip clickable={false}
                            onClick={() => {}} label="Active" color="success" variant="outlined" />
          ) : (
             <Chip clickable={false}
                            onClick={() => {}} label="Blocked" color="error" variant="outlined" />
          ),
      },
    ],
    [navigate, globalFilter]
  );
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4, px: { xs: 0.5, sm: 1 } }}>
    <MaterialReactTable
      columns={columns}
      data={users}
      manualPagination
      manualFiltering
      enableGlobalFilter
      onGlobalFilterChange={setGlobalFilter}
      rowCount={totalRows}
      onPaginationChange={setPagination}
      state={{
        pagination,
        isLoading,
        globalFilter,
      }}
      renderTopToolbarCustomActions={() => (
          <Typography
            variant="h6"
          >
            All Users
          </Typography>
      )}
      enableDensityToggle={false}
      enableColumnFilters={false}
      enableHiding={false}
        muiTablePaperProps={{
            elevation: 0,
          }}
          muiTableBodyRowProps={{
            sx: {
              backgroundColor: 'background.paper',
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              backgroundColor: 'background.paper',
            },
          }}

          //Top toolbar styling
          muiTopToolbarProps={{
            sx: {
              backgroundColor: 'background.paper',
              borderBottom: '1px solid',
              borderColor: 'divider',
            },
          }}
          //Bottom toolbar styling
          muiBottomToolbarProps={{
            sx: {
              backgroundColor: 'background.paper',
            },
          }}
    />
    </Container>
  );
};

export default Users;
